import { FC } from 'react';
import { Controller, useFormContext, get, FieldError } from 'react-hook-form';

import { FormElementProps } from '@/components';
import { renderRequiredLabel } from '@/components/FormElements/RequiredFieldLabel';

import { BaseAutocomplete, BaseAutocompleteProps } from '../Autocomplete';

export interface FormAutocompleteFieldProps
  extends Omit<BaseAutocompleteProps, 'value'>,
    FormElementProps {
  name: string;
  emptyContent?: React.ReactNode;
  onChipDelete?: (value: string | number) => void;
  handleChange?: (name: string, value: string | string[]) => void;
  onInputChange?: (name: string) => void;
  'data-testid'?: string;
}

export const FormAutocompleteField: FC<FormAutocompleteFieldProps> = (
  props,
) => {
  const {
    name,
    items,
    label,
    rules,
    defaultValue,
    handleChange,
    onInputChange,
    'data-testid': dataTestId,
    ...restProps
  } = props;

  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = (get(errors, name) as FieldError)?.message;
  const isRequired = !!rules?.required;

  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => (
        <BaseAutocomplete
          {...restProps}
          {...(dataTestId ? { 'data-testid': dataTestId } : {})}
          value={value}
          items={items}
          error={error}
          label={renderRequiredLabel(label, isRequired)}
          onChange={(e) => {
            onChange(e);
            if (handleChange) handleChange(name, e);
          }}
          onInputChange={onInputChange}
        />
      )}
      name={name}
      rules={rules}
    />
  );
};
